import React from 'react';
import { NoCategories } from '@Components/Category/NoCategories.component';

interface NoCoFCategoriesProps {
	handleAddCategoryClicked: () => void;
}

export const NoCoFCategories: React.FC<NoCoFCategoriesProps> = ({
	handleAddCategoryClicked,
}) => (
	<NoCategories
		section="cof"
		handleAddCategoryClicked={handleAddCategoryClicked}
	/>
);
